import { Home, LayoutGrid, Sparkles, ShoppingCart } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";
import { useState } from "react";
import { useCart } from "@/contexts/CartContext";
import { useAuth } from "@/contexts/AuthContext";
import { useIsSeller } from "@/hooks/useIsSeller";
import { useIsMobile } from "@/hooks/use-mobile";
import { CategoryBrowser } from "./CategoryBrowser";
import { useScrollToTop } from "@/hooks/useScrollToTop";


export function BottomNavigation() {
  const [isCategoryBrowserOpen, setIsCategoryBrowserOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { count } = useCart();
  const { user } = useAuth();
  const { isSeller } = useIsSeller();
  const isMobile = useIsMobile();
  const handleScrollToTop = useScrollToTop();

  // Only show on mobile
  if (!isMobile) return null;

  const isActive = (path: string) => {
    if (path === "/") return location.pathname === "/";
    if (path === "/cart") return location.pathname === "/cart";
    if (path === "/new-arrivals") return location.pathname === "/new-arrivals";
    return location.pathname === path;
  };


  return (
    <>
      <nav id="mobile-bottom-nav" className="fixed bottom-0 left-0 right-0 z-50 bg-card border-t border-border shadow-lg">
        <div className="flex items-center justify-around h-16 px-2">
          {/* Home */}
          <button
            onClick={() => handleScrollToTop("/")}
            className={`flex flex-col items-center justify-center p-2 min-w-[60px] perlla-transition ${
              isActive("/") ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <Home className="h-5 w-5 mb-1" />
            <span className="text-xs font-medium">Home</span>
          </button>

          {/* Categories */}
          <button
            onClick={() => setIsCategoryBrowserOpen(true)}
            className="flex flex-col items-center justify-center p-2 min-w-[60px] text-muted-foreground hover:text-primary perlla-transition"
          >
            <LayoutGrid className="h-5 w-5 mb-1" />
            <span className="text-xs font-medium">Browse</span>
          </button>

          {/* New Arrivals */}
          <button
            onClick={() => handleScrollToTop("/new-arrivals")}
            className={`flex flex-col items-center justify-center p-2 min-w-[60px] perlla-transition ${
              isActive("/new-arrivals") ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <Sparkles className="h-5 w-5 mb-1" />
            <span className="text-xs font-medium">New</span>
          </button>

          {/* Cart */}
          <button
            onClick={() => handleScrollToTop("/cart")}
            className={`flex flex-col items-center justify-center p-2 min-w-[60px] perlla-transition relative ${
              isActive("/cart") ? "text-primary" : "text-muted-foreground"
            }`}
          >
            <div className="relative">
              <ShoppingCart className="h-5 w-5 mb-1" />
              {count > 0 && (
                <span className="absolute -top-2 -right-2 bg-primary text-primary-foreground text-xs rounded-full h-4 w-4 flex items-center justify-center">
                  {count}
                </span>
              )}
            </div>
            <span className="text-xs font-medium">Cart</span>
          </button>
        </div>
      </nav>

      {/* Modals */}
      <CategoryBrowser 
        isOpen={isCategoryBrowserOpen} 
        onClose={() => setIsCategoryBrowserOpen(false)} 
      />
    </>
  );
}